<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
				<el-button type="primary" @click="exportFunc()">导出</el-button>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"/>
                </div>
            
                <div class="common-header-block">
                    <el-input
                            class="common-el-input"
                            placeholder="请输入用户ID"
                            v-model="searchVal">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
				<div class="common-header-block">
				    <el-input
				            class="common-el-input"
				            placeholder="请输入战队ID"
				            v-model="clubId">
				        <i slot="prefix" class="el-input__icon el-icon-search"></i>
				    </el-input>
				</div>
				<div class="common-header-block">
				    <el-input
				            class="common-el-input"
				            placeholder="请输入房间ID"
				            v-model="roomId">
				        <i slot="prefix" class="el-input__icon el-icon-search"></i>
				    </el-input>
				    <el-button type="primary" @click="getList()">搜索</el-button>
				</div>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    height="100%"
                    row-key="id"
                    @selection-change="selection = $event"
                    :data="GameDetailList.beanList">
               <el-table-column  label="房间Id" align="center">
                 <template slot-scope="scope">{{scope.row.roomId}}</template>
               </el-table-column>
               <el-table-column  label="房间名称" align="center">
                 <template slot-scope="scope">{{scope.row.roomName}}</template>
               </el-table-column>
			   
			   <el-table-column  label="用户id" align="center">
			     <template slot-scope="scope">{{scope.row.userId}}</template>
			   </el-table-column>
			   <el-table-column  label="用户名称" align="center">
			     <template slot-scope="scope">{{scope.row.nickname}}</template>
			   </el-table-column>
			   <el-table-column  label="战队id" align="center">
			     <template slot-scope="scope">{{scope.row.clubId}}</template>
			   </el-table-column>
			   <el-table-column  label="战队名称" align="center">
			     <template slot-scope="scope">{{scope.row.clubName}}</template>
			   </el-table-column>
			   
			   <el-table-column  label="下注局数" align="center">
			     <template slot-scope="scope">{{scope.row.betCng}}</template>
			   </el-table-column>
                       
               <el-table-column  label="总下注量" align="center" >
                 <template slot-scope="scope">{{scope.row.totalBet}}</template>
               </el-table-column>
               <el-table-column  label="总战绩" align="center" >
                 <template slot-scope="scope">{{scope.row.totalEarn}}</template>
               </el-table-column>
			   <el-table-column  label="总带入" align="center" >
			     <template slot-scope="scope">{{scope.row.bringIn}}</template>
			   </el-table-column>
			   
			   <el-table-column  label="是否点亮星标" align="center">
			     <template slot-scope="scope">{{scope.row.isStarLight==1?"是":"否"}}</template>
			   </el-table-column>
               <el-table-column  label="时间" align="center" >
                 <template slot-scope="scope">{{getLocalTime(scope.row.dateTime)}}</template>
               </el-table-column>
		
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="GameDetailList.total"
                @current-change="getList($event)"
                :current-page="currentPage"/>
				

    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                date: null,
                type: '',
                status: -1,
                currentPage: 1,
                show: false,
                selection: [],
                idList: [],
				searchVal:"",
				roomId:"",
				clubId:"",
            }
        },
        computed: {
            ...mapState('system', ['GameDetailList']),
        },
        created() {
            this.getList()
        },
        filters: {
           
        },
        methods: {
			...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('system', ['getCbGameDetailList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getCbGameDetailList({
                    randomId: this.searchVal,
					roomId: this.roomId,
					clubId:this.clubId,
					startTime:this.date==null?null:this.date[0],
					endTime:this.date==null?null:this.date[1],
                    page
                }).then(() => {
                    this.loading = false;
                })
            },
            exportFunc(id) {
				
              this.setStateDownloadConfig({
                  action: '/system/downLoadGameDetail/export',
                  info: [
						{name: 'randomId', value: this.searchVal},
						{name: 'roomId', value: this.roomId},
						{name: 'clubId', value: this.clubId},
						{name: 'startTime', value: this.date ? this.date[0] : ''},
						{name: 'endTime', value: this.date ? this.date[1] : ''},
                  ]
              });
            },
			getLocalTime(nS) {
			    if(nS==null){
			        return "";
			    }
			    //将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
			    let date = new Date(nS);
			    let year = date.getFullYear();
			    let month = date.getMonth()+1;
			    let day = date.getDate();
			    let hh = date.getHours();
			    let mm = date.getMinutes();
			    let ss = date.getSeconds();
			
			    month = month < 10 ? "0"+month:month;
			    day = day < 10 ? "0"+day:day;
			    hh = hh < 10 ? "0"+hh:hh;
			    mm = mm < 10 ? "0"+mm:mm;
			    ss = ss < 10 ? "0"+ss:ss;
			    date = year+'-'+month+'-'+day+" "+hh+":"+mm+":"+ss;
			    return date;
			},
			buttonType(row){
			     if (row.autoCreate ==0) {
			     return 'danger';
			     } 
			     return 'primary';
			 }
        }
    }
</script>

<style  scope>

	.el-slider__runway{
	    width: 240px;
	    float: right;
	}
	.custom-slider .el-slider__marks-text {
	    transform: translateY(-125%) translateX(-50%); /* 将标记移动到滑块上方 */
	    /* transform:translateX(-100%) tr; */
	    font-size: 12px; /* 减小文字大小 */
	    width: 40px;
	}
</style>